<template>
  <div class="cf-node-properties__input">
    <input
      v-model="inputValue"
      class="form-control"
      :class="{'invalid': error}"
      type="text" 
      :placeholder="placeholder"
      :required="required"
      @blur="onBlur"
    >
    <div
      v-if="errorMessage" 
      class="cf-node-properties__input-error"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: [String, Boolean, Number],
      default: ''
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    inputValue: {
      get() { 
        return this.value;
      },
      set(inputValue) {
        this.$emit('input', inputValue);
      }
    },
    errorMessage() {
      return this.error?.errorMessage;
    }
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    }
  }
};
</script>